import { render, staticRenderFns } from "./homeDemand.vue?vue&type=template&id=33f5d7b0&"
import script from "./homeDemand.vue?vue&type=script&lang=js&"
export * from "./homeDemand.vue?vue&type=script&lang=js&"
import style0 from "./homeDemand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports